import React, { useContext } from 'react'
import styled from 'styled-components'
import GatsbyImage from 'gatsby-image'
import { SiteLink } from '../shared/SiteLink'
import { useInView } from 'react-intersection-observer'
import { LayoutContext, useUI } from '../../contexts'
import { useBlogPostClickedTracking } from '../../hooks/tracking'
import { getAvailable } from '../../utils'

const BlogPosts = ({ contentfulBlogPosts, selectedBlogPosts, location }) => {
  const { node_locale, currency } = useContext(LayoutContext)

  const Post = ({ title, image, type, slug, index, location }) => {
    const isIE =
      /*@cc_on!@*/ false ||
      (typeof window !== `undefined` && !!document.documentMode)
    const [thumbnail, thumbnailInView] = isIE
      ? []
      : useInView({ triggerOnce: true, threshold: 0 })

    return (
      <SiteLink
        to={slug}
        onClick={() =>
          useBlogPostClickedTracking({
            currency: currency?.code,
            locale: node_locale,
            postType: type,
            name: title,
            position: index + 1,
            destination: `/${node_locale}/${slug}/`,
            linkType: 'Image',
            viewType: 'Blog Page',
          })
        }
        state={{ referrer: location.pathname }}
      >
        <ImageWrapper ref={thumbnail}>
          {image && !isIE && thumbnailInView ? (
            <StyledImage fluid={image.fluid} alt={image.title} />
          ) : image && isIE ? (
            <StyledImage fluid={image.fluid} alt={image.title} />
          ) : null}
          <Label>{type}</Label>
        </ImageWrapper>
        <Title>{title}</Title>
      </SiteLink>
    )
  }

  return (
    <StyledBlogPosts>
      {selectedBlogPosts
        ? selectedBlogPosts
            .filter(getAvailable)
            .map(({ title, image, type, slug }, index) => (
              <Post
                title={title}
                image={image}
                type={type}
                slug={slug}
                index={index}
                location={location}
                key={index}
              />
            ))
        : contentfulBlogPosts.nodes
            .filter(getAvailable)
            .map(({ title, image, type, slug }, index) => (
              <Post
                title={title}
                image={image}
                type={type}
                slug={slug}
                index={index}
                location={location}
                key={index}
              />
            ))}
    </StyledBlogPosts>
  )
}

const StyledBlogPosts = styled.section`
  padding: ${(props) => props.theme.space.marginMobile * 2}vw
    ${(props) => props.theme.space.marginMobile}vw;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: ${(props) => props.theme.space.marginMobile}vw;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    grid-template-columns: repeat(3, 1fr);
    grid-gap: ${(props) => props.theme.space.marginDesktop * 8}vw;
    padding: ${(props) => props.theme.space.marginDesktop * 10}vw
      ${(props) => props.theme.space.marginDesktop * 10}vw;
  }
`

const Label = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  font-size: 2.93333vw;
  display: inline-block;
  background: ${(props) => props.theme.colors.blue};
  text-align: center;
  color: white;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding: ${(props) => props.theme.space.marginMobile / 2}vw
    ${(props) => props.theme.space.marginMobile / 2}vw;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    font-size: ${(props) => props.theme.fontSize.d12};
    padding: ${(props) => props.theme.space.marginDesktop}vw
      ${(props) => props.theme.space.marginDesktop}vw;
  }
`

const StyledImage = styled(GatsbyImage)`
  z-index: -1;
  height: 100%;
`

const ImageWrapper = styled.div`
  position: relative;
  margin-bottom: ${(props) => props.theme.space.marginMobile / 2}vw;
  height: 60vw;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    height: 30vw;
    margin-bottom: ${(props) => props.theme.space.marginDesktop * 2}vw;
  }
`
const Title = styled.h2`
  font-size: ${(props) => props.theme.space.m23};
  line-height: 4.8vw;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    font-size: 1.18vw;
    line-height: 1.875vw;
  }
`

export default BlogPosts
